import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';

@Injectable({
  providedIn: 'root'
})
export class ModsService extends InsectaServiceBase {
  public getRecipesLookup(): Observable<Record<string, string>> {
    return this.get<Record<string, string>>(`/mods/recipes/lookup`, `v1`);
  }

  public getRecipeIngredients(recipeId: string, targetValue: number): Observable<any[]> {
    return this.get<any[]>(`/mods/recipes/${recipeId}/${targetValue}`, `v1`);
  }
}
